import { connect } from "vuex-connect";
// import log from 'loglevel';
import { BlockProgress } from "../../../components";

export default connect({
  stateToProps: {
    show: state => state.common.isBusy
  }
})(BlockProgress.name, BlockProgress);
